import bg from "../assets/bg.png";
import chef from "../assets/chef.png";
import gallery01 from "../assets/gallery01.png";
import gallery02 from "../assets/gallery02.png";
import gallery03 from "../assets/gallery03.png";
import gallery04 from "../assets/gallery04.png";
import gallery05 from "../assets/gallery05.png";
import knife from "../assets/knife.png";
import logo from "../assets/logo.png";
import menu from "../assets/menu.png";
import overlaybg from "../assets/overlaybg.png";
import spoon from "../assets/spoon.svg";
import chai from "../assets/chai.png";
import findus from "../assets/findus.png";
import sign from "../assets/signature.png";
import quote from "../assets/quote.png";
import STK from "../assets/STK.png";

export default {
  bg,
  chef,
  STK,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  gallery05,
  knife,
  logo,
  menu,
  overlaybg,
  spoon,
  chai,
  findus,
  sign,
  quote,
};
